// export interface JourneyNode {
//    id: number
//    ed: [  // tuple
//       number, // ENode.id
//       number, // ENode.x
//       number, // ENode.y
//       number, // ENode.height
//       number, // ENode.width
//       number, // ENode.frame
//       number, // ENode.frame_clr
//       number, // ENode.icon
//       number, // ENode.icon_clr
//    ]
//    lnto: LineConnectionList,
//    lnfr: LineConnectionList
//    data: {
//       title: string
//       description: string
//       delay: number
//       delay_m: number
//       type: number

import { NodeConditionVariation, NodeType } from '@journeys/Enums';
import { EventParticipantStatus } from './ConditionList';

//       segment?: JourneyNodeSegment
//       task?: JourneyNodeTask
//       conditions?: Array<JourneyNodeCondition>
//    }
//    runtime: {
//       relVertexFunc?: (...args: any) => any
//       cache: {
//          icon_clr: number
//          frame_clr: number
//       }
//    }
// }

export const staticPresetsStart: any = {
    List: {
        id: 25,
        x: 0,
        y: 0,
        h: 70,
        w: 70,
        i: 17,
        ic: 109,
        f: 2,
        fc: 168,
        data: {
            title: 'List',
            name: 'List',
            description: '',
            type: 1,
            var: 1,
            delay_d: 0,
            conditions: [],
            segments: [],
            segment: {
                Type: 'SegmentGroup',
                Bool: 1,
                Segments: [],
            },
            ListId: null,
            ListIds: [],
            SegmentIds: [],
        },
        lnto: {},
        lnfr: {},
        runtime: {
            cache: {},
        },
    },
};
export const staticPresetsActions: any = {
    Email: {
        id: 22,
        x: 0,
        y: 0,
        h: 70,
        w: 70,
        i: 20,
        ic: 109,
        f: 2,
        fc: 60,
        lnto: {},
        lnfr: {},
        data: {
            title: 'Email',
            name: 'Email',
            description: '',
            type: 2,
            var: 1,
            delay_d: 0,
            conditions: [],
            segment: {
                Type: 'SegmentGroup',
                Bool: 1,
                Segments: [],
            },
        },
        runtime: {
            cache: {},
        },
    },
    Sms: {
        id: 22,
        x: 0,
        y: 0,
        h: 70,
        w: 70,
        i: 2,
        ic: 109,
        f: 2,
        fc: 60,
        lnto: {},
        lnfr: {},
        data: {
            title: 'Sms',
            name: 'Sms',
            description: '',
            type: 2,
            var: 4,
            delay_d: 0,
            conditions: [],
            segment: {
                Type: 'SegmentGroup',
                Bool: 1,
                Segments: [],
            },
        },
        runtime: {
            cache: {},
        },
    },
    Event: {
        id: 26,
        x: 0,
        y: 0,
        h: 70,
        w: 70,
        i: 19,
        ic: 91,
        f: 3,
        fc: 60,
        data: {
            title: 'Event',
            name: 'Event',
            description: '',
            type: 2,
            var: 2,
            delay_d: 0,
            conditions: [],
            segment: {
                Type: 'SegmentGroup',
                Bool: 1,
                Segments: [],
            },
        },
        lnto: {},
        lnfr: {},
        runtime: {
            cache: {},
            nx: -103,
            ny: -623,
        },
    },
    Survey: {
        id: 27,
        x: 0,
        y: 0,
        h: 70,
        w: 70,
        i: 1,
        ic: 91,
        f: 3,
        fc: 60,
        data: {
            title: 'Survey',
            name: 'Survey',
            description: '',
            type: 2,
            var: 3,
            delay_d: 0,
            conditions: [],
            segment: {
                Type: 'SegmentGroup',
                Bool: 1,
                Segments: [],
            },
        },
        lnto: {},
        lnfr: {},
        runtime: {
            cache: {},
        },
    },
};
// TODO types like email segment event conditions
export const staticPresetsConditions: any = {
    Wait: {
        id: 22,
        x: 0,
        y: 0,
        h: 36,
        w: 36,
        i: 28,
        ic: 109,
        f: 2,
        fc: 216,
        data: {
            title: '',
            name: 'Wait',
            description: '',
            type: NodeType.Condition,
            var: 1,
            delay_d: 7,
            delay_h: 0,
            delay_m: 0,
            conditions: [],
            segment: {
                Type: 'SegmentGroup',
                Bool: 1,
                Segments: [],
            },
        },
        lnto: {},
        lnfr: {},
        runtime: {
            cache: {},
        },
    },
    Condition: {
        id: 24,
        x: 0,
        y: 0,
        h: 36,
        w: 36,
        i: 18,
        ic: 109,
        f: 2,
        fc: 216,
        data: {
            title: 'Condition',
            name: 'Condition',
            description: '',
            type: NodeType.Condition,
            var: 2,
            delay_d: 0,
            conditions: [],
            segment: {
                Type: 'SegmentGroup',
                Bool: 1,
                Segments: [],
            },
        },
        lnto: {},
        lnfr: {},
        runtime: {
            cache: {},
        },
    },
    EmailBounced: {
        id: 31,
        x: 0,
        y: 0,
        h: 36,
        w: 36,
        i: 33,
        ic: 109,
        f: 2,
        fc: 216,
        data: {
            title: 'Bounced',
            name: 'Bounced',
            description: '',
            type: NodeType.Condition,
            var: 3,
            delay_d: 0,
            conditions: [],
            segment: {
                Type: 'SegmentGroup',
                Bool: 1,
                Segments: [
                    {
                        Type: 'InteractionSegment',
                        Name: null,
                        ObjectId: null,
                        HasInteractions: true,
                        Types: [11],
                    },
                ],
            },
        },
        lnto: {},
        lnfr: {},
        runtime: {
            cache: {},
        },
    },
    EmailOpen: {
        id: 32,
        x: 0,
        y: 0,
        h: 36,
        w: 36,
        i: 34,
        ic: 109,
        f: 2,
        fc: 216,
        data: {
            title: 'Opened',
            name: 'Opened',
            description: '',
            type: NodeType.Condition,
            var: 4,
            delay_d: 0,
            conditions: [],
            segment: {
                Type: 'SegmentGroup',
                Bool: 1,
                Segments: [
                    {
                        Type: 'InteractionSegment',
                        Name: null,
                        ObjectId: null,
                        HasInteractions: true,
                        Types: [4],
                    },
                ],
            },
        },
        lnto: {},
        lnfr: {},
        runtime: {
            cache: {},
        },
    },
    EmailNotOpen: {
        id: 32,
        x: 0,
        y: 0,
        h: 36,
        w: 36,
        i: 39,
        ic: 109,
        f: 2,
        fc: 216,
        data: {
            title: 'Not opened',
            name: 'Not opened',
            description: '',
            type: NodeType.Condition,
            var: 4,
            delay_d: 0,
            conditions: [],
            segment: {
                Type: 'SegmentGroup',
                Bool: 1,
                Segments: [
                    {
                        Type: 'InteractionSegment',
                        Name: null,
                        ObjectId: null,
                        HasInteractions: false,
                        Types: [4],
                    },
                ],
            },
        },
        lnto: {},
        lnfr: {},
        runtime: {
            cache: {},
        },
    },
    EmailUnsub: {
        id: 34,
        x: 0,
        y: 0,
        h: 36,
        w: 36,
        i: 35,
        ic: 109,
        f: 2,
        fc: 216,
        data: {
            title: 'Unsubscribed',
            name: 'Unsubscribed',
            description: '',
            type: NodeType.Condition,
            var: 5,
            delay_d: 0,
            conditions: [],
            segment: {
                Type: 'SegmentGroup',
                Bool: 1,
                Segments: [
                    {
                        Type: 'InteractionSegment',
                        Name: null,
                        ObjectId: null,
                        HasInteractions: true,
                        Types: [9],
                    },
                ],
            },
        },
        lnto: {},
        lnfr: {},
        runtime: {
            cache: {},
        },
    },
    Clicked: {
        id: 33,
        x: 0,
        y: 0,
        h: 36,
        w: 36,
        i: 36, // banned: 37
        ic: 109,
        f: 2,
        fc: 216,
        data: {
            title: 'Clicked',
            name: 'Clicked',
            description: '',
            type: NodeType.Condition,
            var: 6,
            delay_d: 0,
            conditions: [],
            segment: {
                Type: 'SegmentGroup',
                Bool: 1,
                Segments: [
                    {
                        Type: 'InteractionSegment',
                        Name: null,
                        ObjectId: null,
                        HasInteractions: true,
                        Types: [5],
                    },
                ],
            },
        },
        lnto: {},
        lnfr: {},
        runtime: {
            cache: {},
        },
    },
    NotClicked: {
        id: 33,
        x: 0,
        y: 0,
        h: 36,
        w: 36,
        i: 37,
        ic: 109,
        f: 2,
        fc: 216,
        data: {
            title: 'Not clicked',
            name: 'Not clicked',
            description: '',
            type: NodeType.Condition,
            var: 6,
            delay_d: 0,
            conditions: [],
            segment: {
                Type: 'SegmentGroup',
                Bool: 1,
                Segments: [
                    {
                        Type: 'InteractionSegment',
                        Name: null,
                        ObjectId: null,
                        HasInteractions: false,
                        Types: [5],
                    },
                ],
            },
        },
        lnto: {},
        lnfr: {},
        runtime: {
            cache: {},
        },
    },
    AnsweredSurvey: {
        id: 33,
        x: 0,
        y: 0,
        h: 36,
        w: 36,
        i: 40,
        ic: 109,
        f: 2,
        fc: 216,
        data: {
            title: 'Answered',
            name: 'Answered',
            description: '',
            type: NodeType.Condition,
            var: 6,
            delay_d: 0,
            conditions: [],
            segment: {
                Type: 'SegmentGroup',
                Bool: 1,
                Segments: [
                    {
                        Type: 'InteractionSegment',
                        Name: null,
                        ObjectId: null,
                        HasInteractions: false,
                        Types: [5],
                    },
                ],
            },
        },
        lnto: {},
        lnfr: {},
        runtime: {
            cache: {},
        },
    },
    NotAnsweredSurvey: {
        id: 33,
        x: 0,
        y: 0,
        h: 36,
        w: 36,
        i: 41,
        ic: 109,
        f: 2,
        fc: 216,
        data: {
            title: 'Did not answer',
            name: 'Did not answer',
            description: '',
            type: NodeType.Condition,
            var: 6,
            delay_d: 0,
            conditions: [],
            segment: {
                Type: 'SegmentGroup',
                Bool: 1,
                Segments: [
                    {
                        Type: 'InteractionSegment',
                        Name: null,
                        ObjectId: null,
                        HasInteractions: false,
                        Types: [5],
                    },
                ],
            },
        },
        lnto: {},
        lnfr: {},
        runtime: {
            cache: {},
        },
    },
    // TODO add back when icons are in place
    // EventRegistered: {
    //     id: 34,
    //     x: 0,
    //     y: 0,
    //     h: 36,
    //     w: 36,
    //     i: 42,
    //     ic: 109,
    //     f: 2,
    //     fc: 216,
    //     data: {
    //         title: 'Event Registered',
    //         name: 'Event Registered',
    //         description: '',
    //         type: NodeType.Condition,
    //         var: NodeConditionVariation.EventRegistered,
    //         delay_d: 0,
    //         conditions: [],
    //         segment: {
    //             Type: 'SegmentGroup',
    //             Bool: 1,
    //             Segments: [
    //                 {
    //                     Type: 'EventParticipantStatusSegment',
    //                     Name: null,
    //                     EventId: null,
    //                     HasStatus: true,
    //                     Statuses: [EventParticipantStatus.Registered],
    //                 },
    //             ],
    //         },
    //     },
    //     lnto: {},
    //     lnfr: {},
    //     runtime: {
    //         cache: {},
    //     },
    // },
    // EventInvited: {
    //     id: 35,
    //     x: 0,
    //     y: 0,
    //     h: 36,
    //     w: 36,
    //     i: 43,
    //     ic: 110,
    //     f: 2,
    //     fc: 217,
    //     data: {
    //         title: 'Event Invited',
    //         name: 'Event Invited',
    //         description: '',
    //         type: NodeType.Condition,
    //         var: NodeConditionVariation.EventInvited,
    //         delay_d: 0,
    //         conditions: [],
    //         segment: {
    //             Type: 'SegmentGroup',
    //             Bool: 1,
    //             Segments: [
    //                 {
    //                     Type: 'EventParticipantStatusSegment',
    //                     Name: null,
    //                     EventId: null,
    //                     HasStatus: true,
    //                     Statuses: [EventParticipantStatus.Invited],
    //                 },
    //             ],
    //         },
    //     },
    //     lnto: {},
    //     lnfr: {},
    //     runtime: {
    //         cache: {},
    //     },
    // },
    // EventWaitlist: {
    //     id: 36,
    //     x: 0,
    //     y: 0,
    //     h: 36,
    //     w: 36,
    //     i: 44,
    //     ic: 111,
    //     f: 2,
    //     fc: 218,
    //     data: {
    //         title: 'Event Waitlist',
    //         name: 'Event Waitlist',
    //         description: '',
    //         type: NodeType.Condition,
    //         var: NodeConditionVariation.EventWaitlist,
    //         delay_d: 0,
    //         conditions: [],
    //         segment: {
    //             Type: 'SegmentGroup',
    //             Bool: 1,
    //             Segments: [
    //                 {
    //                     Type: 'EventParticipantStatusSegment',
    //                     Name: null,
    //                     EventId: null,
    //                     HasStatus: true,
    //                     Statuses: [EventParticipantStatus.Waitlist],
    //                 },
    //             ],
    //         },
    //     },
    //     lnto: {},
    //     lnfr: {},
    //     runtime: {
    //         cache: {},
    //     },
    // },
    // EventAccepted: {
    //     id: 37,
    //     x: 0,
    //     y: 0,
    //     h: 36,
    //     w: 36,
    //     i: 45,
    //     ic: 112,
    //     f: 2,
    //     fc: 219,
    //     data: {
    //         title: 'Event Accepted',
    //         name: 'Event Accepted',
    //         description: '',
    //         type: NodeType.Condition,
    //         var: NodeConditionVariation.EventAccepted,
    //         delay_d: 0,
    //         conditions: [],
    //         segment: {
    //             Type: 'SegmentGroup',
    //             Bool: 1,
    //             Segments: [
    //                 {
    //                     Type: 'EventParticipantStatusSegment',
    //                     Name: null,
    //                     EventId: null,
    //                     HasStatus: true,
    //                     Statuses: [EventParticipantStatus.Accepted],
    //                 },
    //             ],
    //         },
    //     },
    //     lnto: {},
    //     lnfr: {},
    //     runtime: {
    //         cache: {},
    //     },
    // },
    // EventDeclined: {
    //     id: 38,
    //     x: 0,
    //     y: 0,
    //     h: 36,
    //     w: 36,
    //     i: 46,
    //     ic: 113,
    //     f: 2,
    //     fc: 220,
    //     data: {
    //         title: 'Event Declined',
    //         name: 'Event Declined',
    //         description: '',
    //         type: NodeType.Condition,
    //         var: NodeConditionVariation.EventDeclined,
    //         delay_d: 0,
    //         conditions: [],
    //         segment: {
    //             Type: 'SegmentGroup',
    //             Bool: 1,
    //             Segments: [
    //                 {
    //                     Type: 'EventParticipantStatusSegment',
    //                     Name: null,
    //                     EventId: null,
    //                     HasStatus: true,
    //                     Statuses: [EventParticipantStatus.Declined],
    //                 },
    //             ],
    //         },
    //     },
    //     lnto: {},
    //     lnfr: {},
    //     runtime: {
    //         cache: {},
    //     },
    // },
    // EventCancelled: {
    //     id: 39,
    //     x: 0,
    //     y: 0,
    //     h: 36,
    //     w: 36,
    //     i: 47,
    //     ic: 114,
    //     f: 2,
    //     fc: 221,
    //     data: {
    //         title: 'Event Cancelled',
    //         name: 'Event Cancelled',
    //         description: '',
    //         type: NodeType.Condition,
    //         var: NodeConditionVariation.EventCancelled,
    //         delay_d: 0,
    //         conditions: [],
    //         segment: {
    //             Type: 'SegmentGroup',
    //             Bool: 1,
    //             Segments: [
    //                 {
    //                     Type: 'EventParticipantStatusSegment',
    //                     Name: null,
    //                     EventId: null,
    //                     HasStatus: true,
    //                     Statuses: [EventParticipantStatus.Cancelled],
    //                 },
    //             ],
    //         },
    //     },
    //     lnto: {},
    //     lnfr: {},
    //     runtime: {
    //         cache: {},
    //     },
    // },
    // EventAttended: {
    //     id: 40,
    //     x: 0,
    //     y: 0,
    //     h: 36,
    //     w: 36,
    //     i: 48,
    //     ic: 115,
    //     f: 2,
    //     fc: 222,
    //     data: {
    //         title: 'Event Attended',
    //         name: 'Event Attended',
    //         description: '',
    //         type: NodeType.Condition,
    //         var: NodeConditionVariation.EventAttended,
    //         delay_d: 0,
    //         conditions: [],
    //         segment: {
    //             Type: 'SegmentGroup',
    //             Bool: 1,
    //             Segments: [
    //                 {
    //                     Type: 'EventParticipantStatusSegment',
    //                     Name: null,
    //                     EventId: null,
    //                     HasStatus: true,
    //                     Statuses: [EventParticipantStatus.Attended],
    //                 },
    //             ],
    //         },
    //     },
    //     lnto: {},
    //     lnfr: {},
    //     runtime: {
    //         cache: {},
    //     },
    // },
    // EventNoShow: {
    //     id: 41,
    //     x: 0,
    //     y: 0,
    //     h: 36,
    //     w: 36,
    //     i: 49,
    //     ic: 116,
    //     f: 2,
    //     fc: 223,
    //     data: {
    //         title: 'Event NoShow',
    //         name: 'Event NoShow',
    //         description: '',
    //         type: NodeType.Condition,
    //         var: NodeConditionVariation.EventNoShow,
    //         delay_d: 0,
    //         conditions: [],
    //         segment: {
    //             Type: 'SegmentGroup',
    //             Bool: 1,
    //             Segments: [
    //                 {
    //                     Type: 'EventParticipantStatusSegment',
    //                     Name: null,
    //                     EventId: null,
    //                     HasStatus: true,
    //                     Statuses: [EventParticipantStatus.NoShow],
    //                 },
    //             ],
    //         },
    //     },
    //     lnto: {},
    //     lnfr: {},
    //     runtime: {
    //         cache: {},
    //     },
    // },
};

export const staticPresetsPages: any = {
    PageGeneric: {
        id: 27,
        x: 0,
        y: 0,
        h: 156,
        w: 120,
        i: 29,
        ic: 0,
        f: 0,
        fc: 0,
        data: {
            title: 'Generic Page',
            name: 'Generic Page',
            description: '',
            type: 5,
            var: 1,
        },
        lnto: {},
        lnfr: {},
        runtime: {
            cache: {},
        },
    },
    PageImport: {
        id: 28,
        x: 0,
        y: 0,
        h: 156,
        w: 120,
        i: 30,
        ic: 0,
        f: 0,
        fc: 0,
        data: {
            title: 'Import',
            name: 'Import',
            description: '',
            type: 5,
            var: 1,
        },
        lnto: {},
        lnfr: {},
        runtime: {
            cache: {},
        },
    },
    PageOptIn: {
        id: 29,
        x: 0,
        y: 0,
        h: 156,
        w: 120,
        i: 31,
        ic: 0,
        f: 0,
        fc: 0,
        data: {
            title: 'Opt in',
            name: 'Opt in',
            description: '',
            type: 5,
            var: 1,
        },
        lnto: {},
        lnfr: {},
        runtime: {
            cache: {},
        },
    },
    PageSurvey: {
        id: 30,
        x: 0,
        y: 0,
        h: 156,
        w: 120,
        i: 32,
        ic: 0,
        f: 0,
        fc: 0,
        data: {
            title: 'Survey',
            name: 'Survey',
            description: '',
            type: 5,
            var: 1,
        },
        lnto: {},
        lnfr: {},
        runtime: {
            cache: {},
        },
    },
};

/**
 * inner highlight: #8d0069
 * out: #dd29b6
 * faint: #A0C9D3
 */
// 'dyn. Delay': {
//    id: 20,
//    x: 0,
//    y: 0,
//    h: 23,
//    w: 78,
//    i: 26,
//    ic: 1,
//    f: 0,
//    fc: 1,
//    data: {
//       title: 'dyn. Delay',
//       description: '',
//       type: NodeType.Condition,
//       delay: 7,
//       delay_m: 1,
//       conditions: [],
//       segment: {
//          Type: 'SegmentGroup',
//          Bool: 1,
//          Segments: []
//       }
//    },
//    lnto: {},
//    lnfr: {},
//    runtime: {
//       cache: {}
//    }
// },
// 'dyn. If': {
//    id: 19,
//    x: 0,
//    y: 0,
//    h: 16,
//    w: 60,
//    i: 27,
//    ic: 1,
//    f: 0,
//    fc: 1,
//    data: {
//       title: 'dyn. If',
//       description: '',
//       type: NodeType.Condition,
//       delay: 0,
//       delay_m: 1,
//       conditions: [],
//       segment: {
//          Type: 'SegmentGroup',
//          Bool: 1,
//          Segments: []
//       }
//    },
//    lnto: {},
//    lnfr: {},
//    runtime: {
//       cache: {}
//    }
// }

// survey: {
//    h: 100,
//    w: 100,
//    g: {
//       f: 1,
//       fc: 1,
//       i: 1,
//       ic: 137
//    },
//    data: {
//       title: 'Survey',
//       description: '',
//       type: 2,
//       task: {
//          type: 2,
//          id: ''
//       }
//    }
// },
// segment: {
//    h: 100,
//    w: 100,
//    g: {
//       f: 2,
//       fc: 195,
//       i: 4,
//       ic: 145
//    },
//    data: {
//       title: 'Segment',
//       description: '',
//       type: 1,
//       segments: []
//    }
// },

// event: {
//    h: 100,
//    w: 100,
//    g: {
//       f: 1,
//       fc: 50,
//       i: 19,
//       ic: 108
//    },
//    data: {
//       title: 'Event',
//       description: '',
//       type: 2,
//       task: {
//          type: NodeType.Condition,
//          id: ''
//       }
//    }
// },
// sms: {
//    h: 100,
//    w: 100,
//    g: {
//       f: 1,
//       fc: 79,
//       i: 2,
//       ic: 18
//    },
//    data: {
//       title: 'Sms',
//       description: '',
//       type: 2,
//       task: {
//          type: 5,
//          id: ''
//       }
//    }
// },
// form: {
//    h: 100,
//    w: 100,
//    g: {
//       f: 1,
//       fc: 28,
//       i: 11,
//       ic: 149
//    },
//    data: {
//       title: 'Form',
//       description: '',
//       type: 2,
//       task: {
//          type: 4,
//          id: ''
//       }
//    }
// },
// send: {
//    h: 100,
//    w: 100,
//    g: {
//       f: 3,
//       fc: 61,
//       i: 3,
//       ic: 108
//    },
//    data: {
//       title: 'Send',
//       description: '',
//       type: NodeType.Condition,
//       mod: {
//          delay: 0,
//          delay_m: 1,
//          conditions: []
//       }
//    }
// },
// ifCondition: {
//    h: 34,
//    w: 170,
//    g: {
//       f: 5,
//       fc: 3,
//       i: 18,
//       ic: 108
//    },
//    data: {
//       title: 'If Condition',
//       description: '',
//       type: NodeType.Condition,
//       mod: {
//          delay: 0,
//          delay_m: 1,
//          conditions: []
//       }
//    }
// },
// List: {
//    h: 100,
//    w: 100,
//    g: {
//       f: 3,
//       fc: 107,
//       i: 17,
//       ic: 108
//    },
//    data: {
//       title: 'List',
//       description: '',
//       type: 1,
//       segments: []
//    }
// },
// bounce: {
//    h: 34,
//    w: 170,
//    g: {
//       f: 5,
//       fc: 207,
//       i: 21,
//       ic: 198
//    },
//    data: {
//       title: 'Bounce',
//       description: '',
//       type: NodeType.Condition,
//       mod: {
//          delay: 0,
//          delay_m: 1,
//          conditions: []
//       }
//    }
// },
// error: {
//    h: 34,
//    w: 170,
//    g: {
//       f: 5,
//       fc: 2,
//       i: 22,
//       ic: 108
//    },
//    data: {
//       title: 'Error',
//       description: '',
//       type: NodeType.Condition,
//       mod: {
//          delay: 0,
//          delay_m: 1,
//          conditions: []
//       }
//    }
// },
// opened: {
//    h: 34,
//    w: 170,
//    g: {
//       f: 5,
//       fc: 32,
//       i: 23,
//       ic: 18
//    },
//    data: {
//       title: 'Opened',
//       description: '',
//       type: NodeType.Condition,
//       mod: {
//          delay: 0,
//          delay_m: 1,
//          conditions: []
//       }
//    }
// },
// Wait: {
//    h: 67,
//    w: 67,
//    g: {
//       f: 3,
//       fc: 197,
//       i: 13,
//       ic: 180
//    },
//    data: {
//       title: 'Wait',
//       description: '',
//       type: NodeType.Condition,
//       mod: {
//          delay: 1,
//          delay_m: 1,
//          conditions: []
//       }
//    }
// },
// Pause: {
//    h: 67,
//    w: 67,
//    g: {
//       f: 3,
//       fc: 34,
//       i: 14,
//       ic: 108
//    },
//    data: {
//       title: 'Pause',
//       description: '',
//       type: NodeType.Condition,
//       mod: {
//          delay: 1,
//          delay_m: 1,
//          conditions: []
//       }
//    }
// },
// Stop: {
//    h: 67,
//    w: 67,
//    g: {
//       f: 3,
//       fc: 34,
//       i: 16,
//       ic: 108
//    },
//    data: {
//       title: 'Stop',
//       description: '',
//       type: NodeType.Condition,
//       mod: {
//          delay: 1,
//          delay_m: 1,
//          conditions: []
//       }
//    }
// },
// Resume: {
//    h: 67,
//    w: 67,
//    g: {
//       f: 3,
//       fc: 34,
//       i: 15,
//       ic: 108
//    },
//    data: {
//       title: 'Resume',
//       description: '',
//       type: NodeType.Condition,
//       mod: {
//          delay: 1,
//          delay_m: 1,
//          conditions: []
//       }
//    }
// },
// Contact: {
//    h: 67,
//    w: 67,
//    g: {
//       f: 3,
//       fc: 107,
//       i: 7,
//       ic: 108
//    },
//    data: {
//       title: 'Contact',
//       description: '',
//       type: NodeType.Condition,
//       mod: {
//          delay: 0,
//          delay_m: 1,
//          conditions: []
//       }
//    }
// },
// Call: {
//    h: 67,
//    w: 67,
//    g: {
//       f: 4,
//       fc: 55,
//       i: 6,
//       ic: 168
//    },
//    data: {
//       title: 'Call',
//       description: '',
//       type: 2,
//       task: {
//          type: 5,
//          id: ''
//       }
//    }
// },
// Google: {
//    h: 67,
//    w: 67,
//    g: {
//       f: 2,
//       fc: 17,
//       i: 9,
//       ic: 198
//    },
//    data: {
//       title: 'Google',
//       description: '',
//       type: 2,
//       task: {
//          type: 2,
//          id: ''
//       }
//    }
// },
// Facebook: {
//    h: 67,
//    w: 67,
//    g: {
//       f: 2,
//       fc: 107,
//       i: 8,
//       ic: 108
//    },
//    data: {
//       title: 'Facebook',
//       description: '',
//       type: 2,
//       task: {
//          type: 2,
//          id: ''
//       }
//    }
// },
// Instagram: {
//    h: 67,
//    w: 67,
//    g: {
//       f: 2,
//       fc: 191,
//       i: 10,
//       ic: 103
//    },
//    data: {
//       title: 'Instagram',
//       description: '',
//       type: 2,
//       task: {
//          type: 2,
//          id: ''
//       }
//    }
// },
// Click: {
//    h: 67,
//    w: 67,
//    g: {
//       f: 3,
//       fc: 172,
//       i: 12,
//       ic: 120
//    },
//    data: {
//       title: 'Click',
//       description: '',
//       type: NodeType.Condition,
//       mod: {
//          delay: 0,
//          delay_m: 1,
//          conditions: []
//       }
//    }
// }
